module.exports = __webpack_public_path__ + "img/credit-card.b1c70fb6.png";